import { Injectable, inject } from '@angular/core';

import { ParticipantMarketType } from '@cds/betting-offer';
import { isV2CompoundId } from '@frontend/sports/betting-offer/feature/model';
import { MarketSubType, MarketType } from '@frontend/sports/betting-offer/feature/types';
import { MarketGroupingConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';

@Injectable({ providedIn: 'root' })
export class MarketSubTypeLogoService {
    private sitecore = inject(Sitecore);
    private marketGroupingConfig = inject(MarketGroupingConfig);

    getMarketSubTypeLogoTitle(
        fixtureId: string,
        sportId?: SportConstant,
        marketType?: MarketType | ParticipantMarketType,
        marketSubType?: MarketSubType,
        templateId?: string | number,
    ): string | undefined {
        const sitecorePrefix = this.isTv1AndContainsTemplateId(fixtureId, templateId)
            ? this.getTemplateIdSitecorePrefix(sportId, templateId)
            : this.getMarketSubTypeLogoSitecorePrefix(sportId, marketType, marketSubType);
        return sitecorePrefix ? this.sitecore.marketSubtypeLogo.messages[`${sitecorePrefix}-BadgeText`] : undefined;
    }

    getMarketSubTypeSignpostingText(
        sportId?: SportConstant,
        marketType?: MarketType | ParticipantMarketType,
        marketSubType?: MarketSubType,
    ): string | undefined {
        const sitecorePrefix = this.getMarketSubTypeLogoSitecorePrefix(sportId, marketType, marketSubType);
        return sitecorePrefix ? this.sitecore.marketSubtypeLogo.messages[`${sitecorePrefix}-SignpostingText`] : undefined;
    }

    getMarketSubTypeLogoSitecorePrefix(
        sportId?: SportConstant,
        marketType?: MarketType | ParticipantMarketType,
        marketSubType?: MarketSubType,
    ): string | undefined {
        return sportId && marketType && marketSubType ? `${sportId}-${marketType}-${marketSubType}`.toLowerCase() : undefined;
    }

    isTv1AndContainsTemplateId(fixtureId: string, templateId?: string | number): boolean | false {
        return (
            !!fixtureId &&
            !!templateId &&
            !isV2CompoundId(fixtureId) &&
            this.marketGroupingConfig.templateIdsForSecondChanceBadge?.includes(Number(templateId))
        );
    }

    getTemplateIdSitecorePrefix(sportId?: SportConstant, templateId?: string | number): string | undefined {
        return sportId && templateId ? `${sportId}-${templateId}`.toLowerCase() : undefined;
    }
}
